import { logoutUser } from "../../redux/auth/action";

// import { useState } from "react";
import { Menu } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import publicBusLogo from "../../assets/logo/public_bus.png";
import { Fragment } from "react";
import { BrowserRouter as Router } from "react-router-dom";

import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import {
  HomeOutlined,
  CreditCardOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
const { SubMenu } = Menu;

function ReporterSidenav({ color }) {
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");

  const history = useHistory();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logoutUser(history));
  };
  return (
    <>
      <div className="brand" style={{ color: "white" }}>
        <img src={publicBusLogo} alt="" />
        <span style={{ color: "#252525" }}>Public Bus</span>
      </div>
      <hr />
      <Menu theme="light" mode="inline">
        <Menu.Item key="1">
          <NavLink to="dashboard">
            <span
              className="icon"
              style={{
                background: page === "dashboard" ? color : "",
              }}
            >
              <HomeOutlined />
            </span>
            <span className="label">Dashboard</span>
          </NavLink>
        </Menu.Item>
        <SubMenu
          key="SubMenu5"
          className="submenu-items"
          // className="submenu-item"
          icon={
            <span className="icon">
              <CreditCardOutlined />
            </span>
          }
          title="Ticket Managment"
        >
          <Menu.Item key="10" className="submenu-item">
            <NavLink to="booking-information">
              <span className="" ellipsis={true}>
                {/* <HomeOutlined /> */}{" "}
                <Fragment>&nbsp;&nbsp;&nbsp;&nbsp;</Fragment>
              </span>
              <span className="label">Booking Information</span>
            </NavLink>
          </Menu.Item>
          {/* <Menu.Item key="123" className="submenu-item">
            <NavLink to="refund">
              <span className="">
                <Fragment>&nbsp;&nbsp;&nbsp;&nbsp;</Fragment>
              </span>
              <span className="label">Refund</span>
            </NavLink>
          </Menu.Item> */}
        </SubMenu>

        <Menu.Item className="menu-item-header" key="13">
          Report
        </Menu.Item>

        <SubMenu
          key="SubMenu2"
          className="submenu-items"
          // className="submenu-item"
          icon={
            <span className="icon">
              <ExclamationCircleOutlined />
            </span>
          }
          title="Ticket Report"
        >
          {/* <Menu.ItemGroup> */}
          <Menu.Item key="14" className="submenu-item">
            <NavLink to="report">
              <span className="" ellipsis={true}>
                {/* <HomeOutlined /> */}{" "}
                <Fragment>&nbsp;&nbsp;&nbsp;&nbsp;</Fragment>
              </span>
              <span className="label">Report</span>
            </NavLink>
          </Menu.Item>
          <Menu.Item key="15" className="submenu-item">
            <NavLink to="ofecho-report">
              <span className="">
                <Fragment>&nbsp;&nbsp;&nbsp;&nbsp;</Fragment>
              </span>
              <span className="label">Ofecho Report</span>
            </NavLink>
          </Menu.Item>
        </SubMenu>

        <Menu.Item className="menu-item-header" key="16">
          Account Pages
        </Menu.Item>
        <Menu.Item key="17" onClick={() => handleLogout()}>
          <div>
            <span
              className="icon"
              style={{
                background: page === "signout" ? color : "",
              }}
            >
              <HomeOutlined />
            </span>
            <span className="label">Sign Out</span>
          </div>
        </Menu.Item>
        {/* </Menu.Item> */}
      </Menu>
      <div className="aside-footer">
        <div
          className="footer-box"
          style={{
            background: color,
          }}
        >
          <h6>Need Help?</h6>
          <p>Call: 0982117777 / 9439</p>
        </div>
      </div>
    </>
  );
}

export default ReporterSidenav;
